"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteConfig = exports.getConfigs = exports.getConfig = exports.addConfig = void 0;
const shared_1 = require("@getgreenline/shared");
const setBaseUrl = (tenantId, retailerId) => {
    const url = `${shared_1.WORLDPAY_API_URL}/worldpay/tenants/${tenantId}`;
    return retailerId ? `${url}/retailers/${retailerId}/configs` : `${url}/configs`;
};
const addConfig = async (tenantId, retailerId, payload) => {
    const res = await shared_1.axios.post(setBaseUrl(tenantId, retailerId), payload);
    return res.data;
};
exports.addConfig = addConfig;
const getConfig = async (tenantId, retailerId) => {
    const res = await shared_1.axios.get(setBaseUrl(tenantId, retailerId));
    return res.data;
};
exports.getConfig = getConfig;
const getConfigs = async (tenantId) => {
    const res = await shared_1.axios.get(setBaseUrl(tenantId));
    return res.data;
};
exports.getConfigs = getConfigs;
const deleteConfig = async (tenantId, retailerId) => {
    const res = await shared_1.axios.delete(setBaseUrl(tenantId, retailerId));
    return res.data;
};
exports.deleteConfig = deleteConfig;
//# sourceMappingURL=WorldpayConfigAPI.js.map